import { Injectable } from "@angular/core";
import { Action, State, StateContext, Store } from "@ngxs/store";
import { SendDonate } from "../action/donate.action";
import { DonateService } from "../services/donate.service";

export class DonateStateModel {}

@State<DonateStateModel>({
  name: "donate",
  defaults: {}})
@Injectable()
export class DonateState {
  constructor(private _donateService: DonateService) {}

  @Action(SendDonate)
  donate(ctx: StateContext<DonateStateModel>, action: SendDonate) {
    return this._donateService.donate(action.payload);
  }
}
